// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3052e338","977":"ff6291e2"}[chunkId] + ".chunk.js";
};